customElements.whenDefined('scroll-carousel').then(() => {
  /**
   * Resolve EffectCarousel safely
   */
  const BaseCarousel =
    window.EffectCarousel ||
    customElements.get('featured-collections-carousel');

  if (!BaseCarousel) {
    console.warn('[LogoListWithSlider] EffectCarousel not found');
    return;
  }

  /**
   * Resolve animate function (theme-safe)
   */
  const animateFn =
    window.animate ||
    window.vendor?.animate;

  class LogoListWithSlider extends BaseCarousel {
    constructor() {
      super();
    }

    createOnChangeAnimationControls(fromSlide, toSlide) {
      if (!animateFn) return {};

      return {
        leaveControls: () =>
          animateFn(
            fromSlide,
            {
              opacity: [1, 0],
              transform: ['translateY(0)', 'translateY(15px)']
            },
            { duration: 0.3, easing: 'ease-in' }
          ),

        enterControls: () =>
          animateFn(
            toSlide,
            {
              opacity: [0, 1],
              transform: ['translateY(15px)', 'translateY(0)']
            },
            { duration: 0.2, delay: 0.2, easing: 'ease-out' }
          )
      };
    }
  }

  if (!customElements.get('logo-list-with-slider')) {
    customElements.define(
      'logo-list-with-slider',
      LogoListWithSlider
    );
  }

  const slider = document.querySelector('.logo-items-list');
  const wrapper = document.querySelector('.logo-slider-wrapper');

  if (!slider || !wrapper) return;

  let hideTimeout;

  const showArrows = () => {
    wrapper.classList.add('logo-slider--active');

    clearTimeout(hideTimeout);
    hideTimeout = setTimeout(() => {
      wrapper.classList.remove('logo-slider--active');
    }, 1500); // 1.5 sec after last move
  };

  /* On scroll */
  slider.addEventListener('scroll', showArrows);

  /* On drag */
  slider.addEventListener('pointerdown', showArrows);

  /* On arrow click */
  wrapper.querySelectorAll('carousel-prev-button, carousel-next-button')
    .forEach(btn => {
      btn.addEventListener('click', showArrows);
    });

});
